export default {
  labels: {
    card: 'Cartão de Crédito',
    bank_account: 'Conta Bancária',
  },
  alerts: {
    payments_not_configured:
      'Os pagamentos ainda não estão configurados. Contacte o seu fornecedor para os ativar e volte a este passo.',
  },
  buttons: {
    change_payment_method: 'Alterar método de pagamento',
    save_payment_info: 'Guardar dados de pagamento',
  },
  toasts: {
    failed_to_init_payment_setup: 'Falha ao iniciar a configuração de pagamento, recarregue a página',
    successfully_saved_payment_method: 'Dados de pagamento guardados',
  },
};
